import React, { useState, useEffect } from 'react';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import axios from 'axios';
import { Table, Modal, Breadcrumb, Row, Col, Tag, Typography, Space, Tooltip, Upload, Image, Progress, Button, Divider, message } from 'antd';
import DocumentViewer from '../../components/document-viewer/DocumentViewer';
import { CloudUploadOutlined, DeleteOutlined, EyeOutlined, SendOutlined } from '@ant-design/icons';
import ProcessingModal from '../../components/processing/ProcessingModal';

export function ApplicantMER() {
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);

   const [saID, setSaID] = useState(null);
   const [merCompeleted, setMerCompleted] = useState(false);

   const [merID, setMerID] = useState(null);
   const [merList, setMerList] = useState([]);
   const [merData, setMerData] = useState({
      id: null,
      label: null,
      document: null
   });

   const [dpPopData, setDpPopData] = useState({
      document: null,
      status: null,
      receipt_no: null
   });

   const [merDocUploadList, setMerDocUploadList] = useState([]);

   const [modalVisible, setModalVisible] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [percentage, setPercentage] = useState(0);
   const [isUploading, setIsUploading] = useState(false);
   const [recommendation, setRecommendation] = useState(null);
   const [updating, setUpdating] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      GetMER(user_id);
   }, [user_id]);

   const columns = [
      {
         title: 'Medical Exam Result',
         key: 'label',
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Typography.Text>
               {
                  payload.label
               }
            </Typography.Text>
         ),
         width: '30%'
      },
      {
         title: 'Required',
         key: 'required',
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Typography.Text>
               {
                  payload.required === true ? 'Yes' : 'No'
               }
            </Typography.Text>
         ),
         width: '10%'
      },
      {
         title: 'Status',
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Typography.Text>
               {
                  payload.status !== null && payload.status !== '' &&
                  <Tag color={payload.status === 'Uploaded' || payload.status === "Re-uploaded" ? 'green' : 'red'}>
                     {payload.status}
                  </Tag>
               }
            </Typography.Text>
         ),
         width: '10%'
      },
      {
         title: 'Remarks',
         key: 'label',
         ellipsis: {
            showTitle: false,
         },
         className: 'drag-visible',
         render: payload => (
            <Typography.Text>
               {
                  payload.remarks
               }
            </Typography.Text>
         ),
         width: '40%'
      },
      {
         title: 'Action',
         key: 'action',
         className: 'drag-visible',
         render: payload => {
            return <>
               <Space size="small">
                  {
                     (merCompeleted === 0 || merCompeleted === '0') &&
                     <Upload beforeUpload={(file) => { beforeDocUpload(payload.id, file) }} showUploadList={false} accept=".jpg, .png, .bmp" >
                        <Tooltip placement="left" title={payload.document === null || payload.document === '' ? 'Upload ' + payload.label : 'Re-upload ' + payload.label}>
                           <CloudUploadOutlined color='#033D89' style={{ cursor: 'pointer' }}
                              onClick={() => setMerData({ id: payload.id, label: payload.label, document: (payload.preview === "" ? payload.document : payload.preview) })}
                           />
                        </Tooltip>
                     </Upload>
                  }
                  {
                     ((payload.document !== null && payload.document !== '') || (payload.preview !== null && payload.preview !== '')) &&
                     <Tooltip placement="right" title={'Preview ' + payload.label}>
                        <EyeOutlined color='#033D89' style={{ cursor: 'pointer' }}
                           onClick={() => handlePreview(payload.id, payload.label, (payload.preview === "" ? payload.document : payload.preview))}
                        />
                     </Tooltip>
                  }
                  {
                     (payload.preview !== null && payload.preview !== '' && payload.preview !== undefined) &&
                     <Tooltip placement="right" title={'Remove ' + payload.label}>
                        <DeleteOutlined color='#033D89' style={{ cursor: 'pointer' }}
                           onClick={() => handleRemove(payload.id)}
                        />
                     </Tooltip>
                  }
               </Space>
            </>
         },
         width: '20%'
      },
   ].filter(item => !item.hidden);

   const GetMER = async (id) => {
      setIsLoading(true);
      try {
         const response = await axios.get(`${process.env.REACT_APP_API_CPH}/getmer?id=${id}`);
         const data = response.data;

         if (!data || !Array.isArray(data) || data.length === 0) {
            console.warn("No valid MER data returned");
            return; // Exit early if data is invalid
         }

         // Extract and parse the first item
         const firstItem = data[0];
         setSaID(firstItem.id);
         setMerCompleted(firstItem.mer_complete);
         setRecommendation(firstItem.interview_recommendation)
         setDpPopData(JSON.parse(firstItem.dp_pop));

         // Parse mer and add preview immutably
         const merList = JSON.parse(firstItem.mer).map((item) => ({
            ...item,
            preview: "",
         }));

         setMerList(merList);
      } catch (error) {
         console.error("Failed to fetch MER:", error.message);
         // Optionally show a UI error (e.g., with a modal or toast)
         // Example: showErrorModal("Failed to load MER data");
      } finally {
         setIsLoading(false);
      }
   };

   const upload_option = {
      onUploadProgress: (progressEvent) => {
         const { loaded, total } = progressEvent;
         let p = Math.floor((loaded * 100) / total);
         setPercentage(p);
         //console.log(`${percentage} %`)
      }
   }

   const beforeDocUpload = (id, file) => {
      var isValid = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';

      if (!isValid) {
         message.error('You can only upload JPG and PNG files.');
      }

      var isLt = file.size / 1024 / 1024 <= 5;
      if (!isLt) {
         message.error('Image must smaller than 5MB.');
      }

      if (isValid && isLt) {
         handleUploadMERDocList(id, file);
      }
   }

   const handleUploadMERDocList = (id, file) => {
      // Convert file to base64 for preview
      Utils.getBase64(file, (imageb64) => {
         // Update merDocUploadList immutably
         const updatedDocList = merDocUploadList.some((item) => item.id === id)
            ? merDocUploadList.map((item) =>
               item.id === id ? { ...item, document: file } : item
            )
            : [...merDocUploadList, { id, document: file }];

         // Update merList immutably with the preview
         const updatedMerList = merList.map((item) =>
            item.id === id ? { ...item, preview: imageb64 } : item
         );

         // Set the new state
         setMerDocUploadList(updatedDocList);
         setMerList(updatedMerList);
      }, (error) => {
         console.error("Error converting file to base64:", error);
         // Optionally show an error modal or notification to the user
      });
   };

   const handleUploadMERDoc = async () => {
      try {
         // Check if all required documents have files selected
         const hasMissingRequiredDocs = merList.some((item) => item.required && !item.document && !item.preview);

         if (hasMissingRequiredDocs) {
            Modal.error({
               title: "Online Application",
               content: "Please upload all required medical exam results to complete your application process.",
               centered: true,
            });
            return;
         }

         setIsUploading(true);

         // Prepare FormData for file upload
         const formData = new FormData();
         merDocUploadList.forEach((obj) => {
            formData.append("files", obj.document);
         });

         // Upload files to S3
         const uploadUrl = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_ONLINE_APPLICATION_PATH}`;
         const uploadResponse = await axios.post(uploadUrl, formData, upload_option);

         if (!uploadResponse.data) throw new Error("No data returned from upload");

         // Process uploaded file URLs
         const uploadedFiles = uploadResponse.data.split(",");
         const updatedDocList = merDocUploadList.map((doc, index) => ({
            ...doc,
            document: uploadedFiles[index] || doc.document, // Fallback if index is out of bounds
         }));

         // Update merList with uploaded file paths and status
         const updatedMerList = merList.map((item) => {
            const matchingDoc = updatedDocList.find((doc) => doc.id === item.id);
            if (matchingDoc) {
               return {
                  ...item,
                  document: `online-application/${matchingDoc.document}`,
                  status: item.remarks === "" ? "Uploaded" : "Re-uploaded",
                  //   remarks: "", // Clear remarks
                  preview: undefined, // Remove preview property
               };
            }
            return item;
         });

         // Submit updated merList to API
         const submitUrl = `${process.env.REACT_APP_API_CPH}/submitmer?id=${saID}`;
         const submitResponse = await axios.post(submitUrl, updatedMerList);

         if (submitResponse.data) {
            // Refresh data and update UI
            await GetMER(user_id); // Assuming GetMER is async; adjust if not
            setMerDocUploadList([]);
            setMerList(updatedMerList); // Update state with new list

            Modal.success({
               title: "Online Application",
               content: "Upload successful.",
               centered: true,
            });
         }
      } catch (error) {
         Modal.error({
            title: "Online Application",
            content: error.response?.data || "An error occurred during upload.",
            centered: true,
         });
      } finally {
         setIsUploading(false);
      }
   };

   const handlePreview = (id, label, document) => {
      setMerData({ id, label, document });
      setModalVisible(true);
   }

   const handleUploadPoP = (file) => {
      const formData = new FormData();
      formData.append('file', file);

      setPercentage(0);
      setIsUploading(true);

      var upload_url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_ONLINE_APPLICATION_PATH}/assessment-pop`;
      axios.post(upload_url, formData, upload_option).then(response => {
         console.log(response);
         if (response.data) {
            let data = response.data;

            var dp_pop_data = dpPopData;
            dp_pop_data.document = data;

            // var url = `${process.env.REACT_APP_API_CPH}/updatesafield?id=${user_id}&fn=dp_pop&fv=${JSON.stringify(dp_pop_data)}`;
            var url = `${process.env.REACT_APP_API_CPH}/updatepop?id=${user_id}&pop=${JSON.stringify(dp_pop_data)}`;

            axios.post(url).then((response) => {
               if (response.data) {
                  Modal.success({
                     title: 'Online Application',
                     content: 'Upload successfull.',
                     centered: true,
                  });

                  setIsUploading(false);
                  setDpPopData(dp_pop_data);
               }
            }, (error) => {
               setIsUploading(false);
               Modal.error({
                  title: 'Online Application',
                  content: error.response.data,
                  centered: true
               });
            });
         }
      }, (error) => {
         console.log(error.message);
         setIsUploading(false);
         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   }

   const UploadButton = () => {
      const props = {
         beforeUpload: file => {
            const isPNG = file.type === 'image/png';
            const isJPG = file.type === 'image/jpeg';
            const isBMP = file.type === 'image/bmp';
            const isPDF = file.type === 'application/pdf';

            const typeValid = isPNG || isJPG || isBMP || isPDF;

            if (typeValid) {
               const sizeValid = file.size / 1024 / 1024 <= 5;

               if (sizeValid) {
                  handleUploadPoP(file);
               } else {
                  Modal.error({
                     title: 'Proof of Payment',
                     content: 'File should be less than 5 MB',
                     centered: true
                  });
               }
            } else {
               Modal.error({
                  title: 'Proof of Payment',
                  content: 'You are not allowed to upload that file type',
                  centered: true
               });
            }
         },
      };
      return (
         <Upload {...props} showUploadList={false}
            accept=".png,.jpg,.pdf,.bmp"
         >
            <Button className='button-shadow' type="primary" size="middle" shape='round' disabled={dpPopData.status === "Paid"}>
               <Typography.Text ellipsis style={{ color: "#fff" }}><CloudUploadOutlined />&nbsp;Upload Proof of Payment</Typography.Text>
            </Button>
         </Upload>
      );
   };

   const handleRemove = (id) => {
      setIsLoading(true);

      // Create a new array for merDocUploadList by filtering out the item with the given id
      const updatedDocList = merDocUploadList.filter((item) => item.id !== id);
      setMerDocUploadList(updatedDocList);

      // Create a new array for merList, updating the preview for the matching id
      const updatedMerList = merList.map((item) =>
         item.id === id ? { ...item, preview: "" } : item
      );
      setMerList(updatedMerList);

      setIsLoading(false);
   }

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className="dashboard-area-all">
            {/* <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <Breadcrumb separator=">" style={{ paddingBottom: '15px' }}>
                     <Breadcrumb.Item>
                        Upload Requirements
                     </Breadcrumb.Item>
                  </Breadcrumb>
               </div>
            </div>

            <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
               <Typography.Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Medical Exam Results</Typography.Title>
            </Divider>

            <Row gutter={12} style={{ overflow: "auto", marginBottom: "10px" }} >
               <Col span={24}>
                  {
                     merList.length > 0
                        ?
                        <div className="dashboard-item-inner3">
                           <Table
                              rowKey={'student-list'}
                              loading={isLoading}
                              size='small'
                              columns={columns}
                              dataSource={merList}
                              pagination={false}
                              scroll={{
                                 y: 'calc(100svh - 13.8rem)',
                                 x: '1000px'
                              }}
                              footer={() =>
                                 <Row>
                                    <Col span={20}>{'Total Records: ' + merList.length}</Col>
                                    <Col span={4} style={{ textAlign: 'center' }}>
                                       {
                                          <Button className='button-shadow' type='primary' shape='round' onClick={() => handleUploadMERDoc()} disabled={merDocUploadList.length > 0 ? false : true}>
                                             <Typography.Text ellipsis style={{ color: "#fff" }}><SendOutlined />&nbsp;Submit</Typography.Text>
                                          </Button>
                                       }
                                       &nbsp;&nbsp;
                                    </Col>
                                 </Row>
                              }
                           />
                        </div>
                        :
                        <></>
                  }

               </Col>
            </Row> */}

            {
               (merCompeleted === 1) ?
               <>
                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Typography.Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Proof of Payment</Typography.Title>
                  </Divider>

                  <Row gutter={[12, 12]} style={{ paddingBottom: '20px' }}>
                     <Col xs={24} sm={24} md={24} lg={24} style={{ display: 'flex', justifyContent: 'left' }}>
                        <Typography.Text>{recommendation}</Typography.Text>
                     </Col>
                  </Row>

                  <Row gutter={12} >
                     <Col span={24} style={{ display: "flex", justifyContent: "left" }}>{UploadButton()}</Col>
                  </Row>
               </>
               :
               <>
                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Typography.Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Proof of Payment</Typography.Title>
                  </Divider>
                  <Row gutter={[12, 12]} style={{ paddingBottom: '20px' }}>
                     <Col xs={24} sm={24} md={24} lg={24} style={{ display: 'flex', justifyContent: 'left' }}>
                        <Typography.Text>{"Uploading of proof of payment not yet available."}</Typography.Text>
                     </Col>
                  </Row>
               </>
            }

            {
               dpPopData.document !== null && dpPopData.document !== '' &&
               <>
                  <Row gutter={12} >
                     <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
                        <DocumentViewer
                           document={dpPopData.document}
                           pdfshowdownload={true}
                           pdfshowprint={true}
                           dvheight={"calc(100vh - 100px)"}
                        />
                     </Col>
                  </Row>
               </>
            }

         </div>

         <Modal
            key='preview-modal'
            title={"Preview " + merData.label}
            centered
            destroyOnClose={true}
            open={modalVisible}
            width='75%'
            onCancel={() => { setModalVisible(false); }}
            footer={[
               <Button key="close" type='primary' shape='round' onClick={() => setModalVisible(false)}>Close</Button>,
            ]}
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={merData.document}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 220px)"}
               />
            </div>
         </Modal>

         <Modal
            key="modal-upload"
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" width="28px" style={{ minWidth: '30px', maxHeight: '100px' }} /> Upload File</div>}
            destroyOnClose={true}
            centered
            open={isUploading}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
         >
            <span>Uploading...</span>
            <Progress
               percent={percentage}
               status="active"
               strokeColor={{
                  '0%': '#5A98D2',
                  '100%': '#1b5596',
               }}
            />
         </Modal>
      </>
   );
}